"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.recentlyCreatedUserTableName = void 0;
exports.recentlyCreatedUserTableName = 'RecentlyCreatedUsers';
